@if (showModal) {
  <div class="tw-modal tw-modal-open" data-theme="oab"
    role="dialog" aria-modal="true" aria-label="Trocar organização e setor">
    <div class="tw-modal-box tw-bg-base-100 tw-max-w-md tw-p-0">
      <!-- Header -->
      <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-px-5 tw-py-4 tw-border-b tw-border-oab-line">
        <div class="tw-min-w-0">
          <h3 class="tw-text-lg tw-font-bold tw-text-oab-ink tw-m-0">Trocar organização/setor</h3>
          <p class="tw-text-sm tw-text-oab-muted tw-mt-0.5">Selecione a organização e o setor de atuação.</p>
        </div>
        <button type="button" class="tw-btn tw-btn-ghost tw-btn-sm tw-btn-circle tw-shrink-0"
          aria-label="Fechar" (click)="closeModal()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <!-- Body -->
      <div class="tw-px-5 tw-py-4">
        <form [formGroup]="selecaoForm" novalidate class="tw-flex tw-flex-col tw-gap-3">
          <div>
            <label class="oab-field-label" for="cs-org">Organização</label>
            <select id="cs-org" class="tw-select tw-select-bordered tw-select-sm tw-w-full"
              formControlName="organizacao" (change)="changeOrganizacao($event.target.value)">
              @for (org of organizacoes(); track org) {
                <option [value]="org.idenOgan">{{ org.nomeOgan }}</option>
              }
            </select>
          </div>
          <div>
            <label class="oab-field-label" for="cs-setor">Setor</label>
            <select id="cs-setor" class="tw-select tw-select-bordered tw-select-sm tw-w-full"
              formControlName="setor" [disabled]="!setoresPorOrg()?.length">
              @for (setor of setoresPorOrg(); track setor) {
                <option [value]="setor.codiSetr">{{ setor.nomeSetr }}</option>
              }
            </select>
          </div>
        </form>
      </div>
      <!-- Footer -->
      <div class="tw-flex tw-justify-end tw-gap-2 tw-px-5 tw-py-4 tw-border-t tw-border-oab-line">
        <button type="button" class="tw-btn tw-btn-outline tw-btn-sm" (click)="closeModal()">Cancelar</button>
        <button type="button" class="tw-btn tw-btn-primary tw-btn-sm" [disabled]="!selecaoForm.valid" (click)="saveSetor()">
          <i class="fa fa-check-circle" aria-hidden="true"></i> Prosseguir
        </button>
      </div>
    </div>
    <div class="tw-modal-backdrop" (click)="closeModal()"></div>
  </div>
}
